import { useMediaQuery } from "@buzzeasy/shared-frontend-utilities";
import { ReactElement, lazy } from "react";
import GlobalStyle from "../../GlobalStyle";
import FirstLaunchHandler from "../../components/FirstLaunchHandler";
import PageTitleAndIconUpdater from "../../components/PageTitleAndIconUpdater";
import Suspended from "../../components/Suspended";
import AppLayout from "../../components/layouts/AppLayout";
import Providers from "./Providers";
import CrmMinimized from "./components/presenters/CrmMinimized";

const LazyCrmAppBar = lazy(() => import("./components/containers/CrmAppBar"));
const LazyCrmMultiTaskDisplay = lazy(() => import("./components/containers/CrmMultiTaskDisplay"));

export default function App(): ReactElement {
  const isMinimized = useMediaQuery("(max-width: 100px)");

  return (
    <Providers>
      <GlobalStyle />
      <PageTitleAndIconUpdater />
      <FirstLaunchHandler />
      <AppLayout
        isHidden={isMinimized}
        header={<Suspended noFallback component={LazyCrmAppBar} />}
        content={<Suspended component={LazyCrmMultiTaskDisplay} />}
      />
      {isMinimized && <CrmMinimized />}
    </Providers>
  );
}
